import React from 'react';
import Navbar from './Navbar/Navbar'
import EventCatScreen from './EventCatScreen';
import PracticeCatScreen from './practice/PracticeCatScreen';


function Home() {

  return (
    <div>

      <EventCatScreen />
    </div>
  );

}

export default Home;
